import React, { useState } from 'react';
import { supabase } from '../supabase';

export default function Notifications() {
  const [title, setTitle] = useState('');
  const [body, setBody] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [history, setHistory] = useState<any[]>([]);

  React.useEffect(() => { fetchHistory(); }, []);

  const fetchHistory = async () => {
    const { data } = await supabase
      .from('app_logs')
      .select('*')
      .eq('type', 'push_notification')
      .order('created_at', { ascending: false })
      .limit(20);
    if (data) setHistory(data);
  };

  const sendNotification = async () => {
    if (!title || !body) { alert('Заполните заголовок и текст'); return; }
    if (!window.confirm(`Отправить уведомление всем пользователям?\n\n"${title}"\n${body}`)) return;
    setLoading(true);

    await supabase.from('app_logs').insert({
      user_id: null,
      type: 'push_notification',
      message: title,
      details: { body, sent_at: new Date().toISOString() },
    });

    setSent(true);
    setLoading(false);
    setTitle('');
    setBody('');
    fetchHistory();
    setTimeout(() => setSent(false), 3000);
  };

  const formatDate = (d: string) => new Date(d).toLocaleString('ru-RU');

  return (
    <div>
      <h1 style={s.title}>🔔 Push уведомления</h1>

      <div style={s.card}>
        <h3 style={{ marginBottom: 16, color: '#222' }}>Отправить всем пользователям</h3>
        <div style={s.field}>
          <label style={s.label}>Заголовок *</label>
          <input
            style={s.input}
            placeholder="Например: Новые рецепты!"
            value={title}
            onChange={e => setTitle(e.target.value)}
            maxLength={50}
          />
          <span style={s.hint}>{title.length}/50</span>
        </div>
        <div style={s.field}>
          <label style={s.label}>Текст уведомления *</label>
          <textarea
            style={{ ...s.input, height: 80, resize: 'vertical' }}
            placeholder="Например: Добавили 10 новых рецептов казахской кухни!"
            value={body}
            onChange={e => setBody(e.target.value)}
            maxLength={150}
          />
          <span style={s.hint}>{body.length}/150</span>
        </div>

        {sent && (
          <div style={s.successMsg}>✅ Уведомление записано! Будет отправлено при следующей синхронизации.</div>
        )}

        <button
          style={{ ...s.btn, opacity: loading ? 0.6 : 1 }}
          onClick={sendNotification}
          disabled={loading}
        >
          {loading ? 'Отправляем...' : '🔔 Отправить уведомление'}
        </button>
      </div>

      <div style={s.card}>
        <h3 style={{ marginBottom: 16, color: '#222' }}>История уведомлений</h3>
        {history.length === 0 ? (
          <p style={{ color: '#aaa' }}>Уведомлений ещё не было</p>
        ) : history.map((h, i) => (
          <div key={i} style={s.histItem}>
            <div style={s.histTitle}>{h.message}</div>
            <div style={s.histBody}>{h.details?.body}</div>
            <div style={s.histDate}>{formatDate(h.created_at)}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

const s: Record<string, React.CSSProperties> = {
  title: { fontSize: 24, fontWeight: 700, color: '#222', marginBottom: 24 },
  card: { backgroundColor: '#fff', borderRadius: 12, padding: 24, marginBottom: 16, boxShadow: '0 1px 4px rgba(0,0,0,0.06)' },
  field: { marginBottom: 16 },
  label: { display: 'block', fontSize: 13, fontWeight: 600, color: '#555', marginBottom: 6 },
  input: { width: '100%', padding: '10px 14px', borderRadius: 8, border: '1px solid #eee', fontSize: 14, outline: 'none', boxSizing: 'border-box' } as any,
  hint: { fontSize: 12, color: '#aaa', float: 'right' },
  btn: { backgroundColor: '#2ECC71', color: '#fff', border: 'none', borderRadius: 10, padding: '12px 24px', fontSize: 15, fontWeight: 600, cursor: 'pointer' },
  successMsg: { backgroundColor: '#d5f5e3', borderRadius: 8, padding: 12, marginBottom: 16, color: '#2ECC71', fontSize: 14 },
  histItem: { borderBottom: '1px solid #f0f0f0', paddingBottom: 12, marginBottom: 12 },
  histTitle: { fontSize: 14, fontWeight: 600, color: '#222' },
  histBody: { fontSize: 13, color: '#555', marginTop: 4 },
  histDate: { fontSize: 12, color: '#aaa', marginTop: 4 },
};